import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Children } from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { range } from '../utils/numbers';
import { carouselClass } from './styles';
import Item from './Item';
import getDataset from '../utils/dom/getDataset';
import { isRTL } from '../config';
var CarouselDefaultProps = {
  animation: 'slide',
  indicatorPosition: 'center',
  indicatorType: 'circle',
  interval: 0,
  className: '',
  style: {}
};

var Carousel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Carousel, _PureComponent);

  var _super = _createSuper2(Carousel);

  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _super.call(this, props);
    _this.count = void 0;
    _this.$timeout = void 0;
    _this.mouseInView = void 0;

    _this.mouseEnterHandler = function () {
      _this.mouseInView = true;

      _this.stop();
    };

    _this.mouseLeaveHandler = function () {
      _this.mouseInView = false;

      _this.start();
    };

    _this.state = {
      current: 0,
      direction: 'stop',
      pre: 0
    };
    _this.start = _this.start.bind(_assertThisInitialized(_this));
    _this.stop = _this.stop.bind(_assertThisInitialized(_this));
    _this.moveTo = _this.moveTo.bind(_assertThisInitialized(_this));
    _this.forward = _this.forward.bind(_assertThisInitialized(_this));
    _this.backward = _this.backward.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(Carousel.prototype), "componentDidMount", this).call(this);

      this.start();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.count > 1 && !this.$timeout) {
        this.start();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(Carousel.prototype), "componentWillUnmount", this).call(this);

      this.stop();
    }
  }, {
    key: "setNext",
    value: function setNext(next) {
      var _this2 = this;

      if (this.mouseInView) return;
      var interval = this.props.interval;

      if (interval > 0 && this.count > 1) {
        this.stop();
        this.$timeout = setTimeout(function () {
          _this2.moveTo(next);
        }, interval);
      }
    }
  }, {
    key: "moveTo",
    value: function moveTo(next) {
      var onMove = this.props.onMove;
      var current = this.state.current;
      if (next === current) return;
      var direction = next > current ? 'forward' : 'backward';

      if (next >= this.count) {
        direction = 'forward';
        next = 0;
      } else if (next < 0) {
        direction = 'backward';
        next = this.count - 1;
      }

      this.setState({
        pre: current,
        current: next,
        direction: direction
      });
      this.setNext(next + 1);
      if (onMove) onMove(next, {
        prev: current,
        direction: direction,
        moveTo: this.moveTo
      });
    }
  }, {
    key: "forward",
    value: function forward() {
      this.moveTo(this.state.current + 1);
    }
  }, {
    key: "backward",
    value: function backward() {
      this.moveTo(this.state.current - 1);
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.$timeout) {
        clearTimeout(this.$timeout);
        this.$timeout = null;
      }
    }
  }, {
    key: "start",
    value: function start() {
      this.setNext(this.state.current + 1);
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this$state = this.state,
          current = _this$state.current,
          pre = _this$state.pre;
      return Children.toArray(this.props.children).map(function (child, i) {
        return (
          /*#__PURE__*/
          React.createElement(Item, {
            key: i,
            current: i === current,
            pre: i === pre && pre !== current
          }, child)
        );
      });
    }
  }, {
    key: "renderCustomIndicator",
    value: function renderCustomIndicator() {
      var _this$props = this.props,
          indicatorType = _this$props.indicatorType,
          indicatorPosition = _this$props.indicatorPosition;
      var current = this.state.current;
      var className = carouselClass('indicator', "indicator-".concat(indicatorPosition));

      if (typeof indicatorType === 'function') {
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: className
          }, indicatorType(current, this.moveTo))
        );
      }

      return null;
    }
  }, {
    key: "renderIndicator",
    value: function renderIndicator() {
      var _this3 = this;

      var _this$props2 = this.props,
          indicatorPosition = _this$props2.indicatorPosition,
          indicatorType = _this$props2.indicatorType;

      if (typeof indicatorType === 'function') {
        return this.renderCustomIndicator();
      }

      var current = this.state.current;
      var className = carouselClass('indicator', "indicator-".concat(indicatorPosition), "indicator-".concat(indicatorType));
      var inds = range(this.count).map(function (i) {
        return (
          /*#__PURE__*/
          React.createElement("a", {
            key: i,
            onClick: _this3.moveTo.bind(_this3, i),
            className: carouselClass(current === i && 'indicator-active')
          }, indicatorType === 'number' ? i + 1 : '')
        );
      });

      if (isRTL()) {
        inds.reverse();
      }

      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className
        }, inds)
      );
    }
  }, {
    key: "renderArrow",
    value: function renderArrow() {
      var _this$props3 = this.props,
          arrowClassName = _this$props3.arrowClassName,
          showArrow = _this$props3.showArrow;
      if (!showArrow) return null;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: classnames(carouselClass('arrow', showArrow === 'hover' && 'arrow-hover'), arrowClassName)
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: carouselClass('arrow-left'),
          onClick: this.backward
        }),
        /*#__PURE__*/
        React.createElement("div", {
          className: carouselClass('arrow-right'),
          onClick: this.forward
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      this.count = Children.toArray(this.props.children).length;
      var _this$props4 = this.props,
          animation = _this$props4.animation,
          style = _this$props4.style;
      var direction = this.state.direction;
      var className = classnames(carouselClass('_', animation, direction), this.props.className);
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({
          className: className,
          style: style,
          onMouseEnter: this.mouseEnterHandler,
          onMouseLeave: this.mouseLeaveHandler
        }, getDataset(this.props)), this.renderItems(), this.renderArrow(), this.count > 1 && this.renderIndicator())
      );
    }
  }]);

  return Carousel;
}(PureComponent);

Carousel.defaultProps = CarouselDefaultProps;
Carousel.displayName = 'ShineoutCarousel';
export default Carousel;